module.exports = __webpack_public_path__ + "img/banner_pc_realme.e8ffe1bd.png";